import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";

import { isNotEmpty } from "@/libs/utils";

import { showToast } from "@/utils/toastUtils";

import { BidDetailType, BidSimilarItem } from "@/types/bid";

import { GetBidDetail, GetBidSimilarList } from "@/services/Bid";

import { useLoadingStore } from "@/stores/Loading";

import BidDetailHeader from "@/components/BidDetailHeader";
import DialogBidSimilarDetail from "@/components/DialogBidSimilarDetail";

export default function BidSimilar() {
  const { startLoading, endLoading } = useLoadingStore();

  const { projectType, projectId } = useParams();

  const [open, setOpen] = useState<boolean>(false);
  const [selectedBid, setSelectedBid] = useState<BidSimilarItem | null>(null);

  const [bidDetail, setBidDetail] = useState<BidDetailType>(
    {} as BidDetailType
  );
  const [bidList, setBidList] = useState<BidSimilarItem[]>([]);

  const getBidDetail = async () => {
    if (isNotEmpty(projectId)) {
      try {
        const result = await GetBidDetail(projectId);
        setBidDetail(result.data.pods[0].content.items[0]);
      } catch (e) {
      } finally {
      }
    }
  };

  const getBidList = async () => {
    try {
      showToast({ message: "공고를 검색합니다." });
      startLoading("bid-similar-list");
      const result = await GetBidSimilarList(projectId);
      if (result.data.success) {
        setBidList(result.data.pods[0].content.items);
        showToast({ message: "공고 검색이 완료되었습니다." });
      }
    } catch (e) {
    } finally {
      endLoading("bid-similar-list");
    }
  };
  useEffect(() => {
    getBidDetail();
    getBidList();
  }, []);
  return (
    <BidDetailHeader
      projectType={projectType ?? ""}
      projectId={bidDetail?.project_id}
      projectTitle={bidDetail?.title}
      isStarred={bidDetail?.is_starred}
      bidLink={bidDetail?.original_url}
      onRefresh={getBidList}
    >
      <div className="mt-5">
        <table className="w-full">
          <colgroup>
            <col width="5%" />
            <col width="25%" />
            <col width="15%" />
            <col width="15%" />
            <col width="15%" />
            <col width="15%" />
            <col width="10%" />
          </colgroup>
          <thead>
            <tr className="h-[30px] bg-dark-brown text-white text-[12px] font-semibold">
              <td className="text-center">#</td>
              <td className="text-center">공고명</td>
              <td className="text-center">수요 기관</td>
              <td className="text-center">수행 기업</td>
              <td className="text-center">등록 일자</td>
              <td className="text-center">사업 규모</td>
              <td className="text-center">입찰 경쟁</td>
            </tr>
          </thead>
          <tbody className="bg-white">
            {bidList.map((bid, bidIndex) => (
              <tr
                key={bidIndex}
                className="h-[50px] px-[20px] py-[10px] border-t-2 border-gray-D text-center text-[12px] font-normal cursor-pointer hover:bg-gray-D"
                onClick={() => {
                  setSelectedBid(bid);
                  setOpen((prev) => !prev);
                }}
              >
                <td>{bidIndex + 1}</td>
                <td className="text-left">{bid.contract_name}</td>
                <td>{bid.dmin_name}</td>
                <td>{bid.corp_name}</td>
                <td>{format(bid.registration_dt, "yyyy-MM-dd")}</td>
                <td>
                  {bid.contract_amount
                    ? bid.contract_amount.toLocaleString()
                    : "공고서 참조"}
                </td>
                <td>{bid.contract_method_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <DialogBidSimilarDetail
          open={open}
          setOpen={setOpen}
          bid={selectedBid}
        />
      </div>
    </BidDetailHeader>
  );
}
